import Button from "@amzn/meridian/esm/components/button";
import Row from "@amzn/meridian/esm/components/row";
import Tag from "@amzn/meridian/esm/components/tag";
import Theme from "@amzn/meridian/esm/components/theme";
import {
  CHIP_BORDER_RADIUS,
  CHIP_FONT_SIZE,
  CHIP_HEIGHT,
} from "./whosWho.constants";

/**
 * Organization filter pills shared by V1 and V2's small-organization presentation.
 */
const WhosWhoOrgPills = ({ orgs, orgColorMap, activeOrg, onSelect }) => {
  if (!orgs || orgs.length === 0) return null;

  return (
    <Row spacing="200" wrap="down" alignmentVertical="center">
      <Theme
        tokens={{
          buttonBorderRadius: CHIP_BORDER_RADIUS,
          buttonHeightSmall: CHIP_HEIGHT,
          buttonSpacingInsetHorizontalSmall: 0,
          tagLabelFontSize: CHIP_FONT_SIZE,
          tagFontSize: CHIP_FONT_SIZE,
        }}
      >
        <Button
          type="link"
          aria-label="Show all organizations"
          aria-pressed={activeOrg === null}
          onClick={() => onSelect(null)}
          size="small"
        >
          <Theme tokens={{ tagIndicatorDiameter: 0 }}>
            <Tag type="neutral">All</Tag>
          </Theme>
        </Button>
        {orgs.map((org) => (
          <Button
            key={org}
            type="link"
            aria-label={org}
            aria-pressed={activeOrg === org}
            onClick={() => onSelect(activeOrg === org ? null : org)}
            size="small"
          >
            <Theme tokens={{ tagBorderColorStatusNeutral: orgColorMap[org] }}>
              <Tag type="neutral">{org}</Tag>
            </Theme>
          </Button>
        ))}
      </Theme>
    </Row>
  );
};

export default WhosWhoOrgPills;
